
import React from "react";

export {AppLevelForbidden403};

const AppLevelForbidden403 = (props: any) => {
    return(<>403 Forbidden</>)
}
